// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileSection_iconDiv__OG6EX {
    width: 100%;
    cursor: pointer;
}

.ProfileSection_iconDiv__OG6EX:hover {
    background-color: #eee;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/ProfileSection/ProfileSection.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".iconDiv {\n    width: 100%;\n    cursor: pointer;\n}\n\n.iconDiv:hover {\n    background-color: #eee;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconDiv": `ProfileSection_iconDiv__OG6EX`
};
export default ___CSS_LOADER_EXPORT___;
